import { timeStampInCurrentTZ } from "../../helper/utils";

/**
 * Show a stored manufacturing clock with the hour, in the viewer's timezone.
 *
 * @param {string|number|Date|null|undefined} iso
 * @return {string}
 */
export const formatProductionClock = iso => {
  if (!iso || iso === "--") {
    return "--";
  }
  const clock = timeStampInCurrentTZ(iso);
  return clock.isValid() ? clock.format("DD MMM YYYY, h:mm A") : "--";
};
